export default __webpack_public_path__ + "static/media/Version (6) - Ultimate Map - Thumbnail.9dce2cc2.png";